import React from 'react';
import { IconProps } from './types';

export const CampaignIcon = (props: IconProps) => {
  const { size = 24, color = 'currentColor', style = {} } = props;

  return (
    <svg
      width={size}
      height={size}
      style={style}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12.0002 6.59998L13.6002 9.89998L17.3002 10.5L14.7002 13L15.3002 16.7L12.0002 15L8.7002 16.7L9.3002 13L6.7002 10.5L10.4002 9.89998L12.0002 6.59998Z'
        stroke='#DFF60D'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
